export const STRIPE_PRE_PAY = 'cdb/payment/stripe/prepay'
export const STRIPE_RECHARGE = 'cdb/payment/stripe/recharge'
export const STRIPE_PAY_OF_CONFIRM = 'cdb/payment/stripe/prepayOfConfirm'
export const STRIPE_RECHARGE_OF_CONFIRM = 'cdb/payment/stripe/rechargeOfConfirm'
export const STRIPE_PAY_CONFIRM = 'cdb/payment/stripe/payConfirm'
export const STRIPE_PREAUTH_OF_CONFIRM = 'cdb/payment/stripe/preauthOfConfirm'
export const STRIPE_PREAUTH_AUTO_CONFIRM = 'cdb/payment/stripe/authConfirm'

export const PAYPAL_PRE_PAY = 'cdb/payment/paypal/prepay'
export const PAYPAL_RECHARGE = 'cdb/payment/paypal/recharge'
export const PAYPAL_EXC_PAY = 'cdb/payment/paypal/excpay'

export const WECHAT_MP_PRE_PAY = 'cdb/payment/wechat_mp/prepay'
export const ALIPAY_PRE_PAY = 'cdb/payment/alipay/prepay'

export const WECHAT_MP_RECHARGE = 'cdb/payment/wechat_mp/recharge'

export const PREPAY_FOR_WEB = 'cdb/payment/vnpay/prepay'
export const CONFIRM_PAY = 'cdb/payment/vnpay/payConfirm'
export const RECHARGE_FOR_WEB = 'cdb/payment/vnpay/recharge'
export const PAY_ORDER_FOR_WEB = 'cdb/payment/vnpay/payOrder'

export const CLIENT_TOKEN = 'cdb/payment/braintree/clientToken'
export const PAYMENT_METHOD = 'cdb/payment/braintree/paymentMethod'
export const PAYMENT_CARD = 'cdb/user/card'
export const PAYMENT_CARD_REMOVE = 'cdb/card/remove'
export const PAYMENT_PREAUTH = 'cdb/payment/braintree/preauth'
